
import Orleans61 from './Orleans 6 (1).webp'
import Orleans62 from './Orleans 6 (2).webp'
import Orleans63 from './Orleans 6 (3).webp'
import Orleans64 from './Orleans 6 (4).webp'
import Orleans65 from './Orleans 6 (5).webp'
import Orleans66 from './Orleans 6 (6).webp'
import Orleans67 from './Orleans 6 (7).webp'
import Orleans68 from './Orleans 6 (8).webp'
import Orleans69 from './Orleans 6 (9).webp'


const Orleans6images =[
Orleans61,Orleans62,Orleans63,Orleans64,Orleans65,Orleans66,Orleans67,Orleans68,Orleans69
]

export default Orleans6images;